import { Layout } from 'antd';
import styled from 'styled-components';

export const LayoutWithMargin = styled(Layout.Content)`
  margin: 0 24px;
`;
